// 인증 관련 storage 키를 한곳에서 관리한다.
// 과거엔 apiConfig.ts(apiAxios 401 핸들러)와 AuthContext.tsx(handleLogout, bare axios
// 401 핸들러)가 서로 다른 키 조합을 지우고 있었다 - apiAxios 쪽은 authToken만 지우고
// authUser/sessionId/activeTeamId를 남겨서, 리다이렉트 전 짧은 순간(또는 리다이렉트가
// 스킵되는 테스트/모의 환경) 동안 "토큰은 없는데 유저 정보는 남아있는" 상태가 됐다.
export function clearAuthStorage(): void {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
  localStorage.removeItem('sessionId');
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('activeTeamId');
  sessionStorage.removeItem('redirectAfterLogin');
}

// 401을 받아도 강제 로그아웃/리다이렉트로 이어지면 안 되는 요청 판단 기준.
// - 로그인 시도 자체의 401(비번 오류 등)
// - 소셜 로그인 콜백/가입 완료
// - 이메일 인증 관련
// 이런 요청은 "아직 로그인 안 된 상태"에서 정상적으로 발생하는 401이라 자동 로그아웃 대상이 아니다.
const AUTH_REDIRECT_EXEMPT_URL_PATTERNS = [
  '/api/auth/login',
  '/api/auth/google',
  '/api/auth/token',
  '/api/auth/naver/callback',
  '/api/auth/kakao/callback',
  '/api/auth/kakao/complete-signup',
  '/api/auth/email-verification/send',
  '/api/auth/email-verification/verify',
];

export function isAuthRedirectExemptUrl(url: string | undefined): boolean {
  if (!url) return false;
  return AUTH_REDIRECT_EXEMPT_URL_PATTERNS.some((pattern) => url.includes(pattern));
}
